module.exports = __webpack_public_path__ + "media/images/auth/circle-b0dab6efb884337ee23a606d42ed52cd.svg";